import {
  Component,
  forwardRef,
  Inject,
  Input,
  ChangeDetectorRef,
  NgZone,
  SimpleChanges,
  OnChanges,
  OnInit
} from '@angular/core';

import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';

import { HaynesProRepairManualModel } from '../typings/haynes-pro.repair-manual';
import { HaynesProService }           from '../haynes-pro.service';
import { HaynesProStoryModel }        from '../typings/haynes-pro.story';
import { HaynesProSubGroupModel }     from '../typings/haynes-pro.sub-group';
import { MessagesService }            from '../../messages/messages.service';
import { VehicleModel }               from '../../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-repair-manuals',
  styles: [ require('./haynes-pro.diagnostic-tool.repair-manuals.component.scss') ],
  template: require('./haynes-pro.diagnostic-tool.repair-manuals.component.html')
})
export class HaynesProDiagnosticToolRepairManualsComponent implements OnChanges, OnInit {

  @BlockUI('haynesProRepairManualsBlock') block: NgBlockUI;

  @Input() isActive  : boolean;
  @Input() subGroups : Array<HaynesProSubGroupModel>;
  @Input() vehicle   : VehicleModel;

  manuals  : Array<HaynesProRepairManualModel> = [];
  stories  : Array<HaynesProStoryModel>        = [];
  story    : HaynesProStoryModel;
  subGroup : HaynesProSubGroupModel;

  isAnimating  = false;
  showDetails  = false;

  constructor (
    private cdr              : ChangeDetectorRef,
    @Inject(forwardRef(() => HaynesProService))
    private haynesProService : HaynesProService,
    @Inject(forwardRef(() => MessagesService)) private messagesService  : MessagesService,
    private zone             : NgZone
  ) {}

  ngOnChanges ( changes : SimpleChanges ) : void {
    if ( changes.isActive && !changes.isActive.isFirstChange() && changes.isActive.currentValue ) {
      const subGroup = this.subGroup
        ? this.subGroup
        : this.subGroups[0];

      subGroup.selected = true;
    }
  }

  ngOnInit () : void {
    if (this.isActive) {
      this.subGroups[0].selected = true;
    }
  }

  backToLists () : void {
    this.isAnimating = true;
    this.showDetails = false;

    this.cdr.markForCheck();

    setTimeout(() => this.isAnimating = false, 450);
  }

  handleSubGroupSelection ( subGroup : HaynesProSubGroupModel ): void {
    this.block.start();

    this.manuals = [];
    this.showDetails   = false;
    this.stories       = [];
    this.subGroup      = subGroup;

    this.haynesProService.getRepairStories(this.vehicle, subGroup.name)
    .then((stories : Array<HaynesProStoryModel> = [] ) => {
      this.stories = stories;

      if (!this.isActive) {
        this.haynesProService.updateSubscriptionStatus(true);
      }
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.block.stop());
  }

  handleStoriesSelection ( story: HaynesProStoryModel ): void {
    this.block.start();

    this.isAnimating = false;
    this.manuals     = [];
    this.showDetails = false;
    this.story       = story;

    this.cdr.markForCheck();

    this.haynesProService.getRepairManuals(this.vehicle, story.story_id)
      .then(( manuals: Array<HaynesProRepairManualModel> = [] ) => {
        this.manuals = manuals[0]?.story_lines || [];

        this.zone.runOutsideAngular(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.zone.run(() => {
                this.isAnimating = true;
                this.showDetails = true;

                this.cdr.markForCheck();

                setTimeout(() => this.isAnimating = false, 450);
              });
            });
          });
        });
      })
      .catch(err => this.messagesService.error(err))
      .finally(() => this.block.stop());
  }

  onCssTransitionEnd ( evt: TransitionEvent ) : void {
    const target = (evt.target as HTMLElement);

    if (!target.classList.contains('shell-details')) {
      return;
    }

    if (evt.propertyName !== 'transform' && evt.propertyName !== 'opacity') {
      return;
    }

    this.isAnimating = false;
  }
}